import React from "react";
import { Stack, IconButton, Typography, Box } from "@mui/material";
import { Instagram, Telegram } from "@mui/icons-material";
import XIcon from "@mui/icons-material/X"; // Replace with the correct icon import if needed
import { darkColors } from "../../theme/colors";
import { assetIcons } from "../../constants/assets";
import { socialRedirectUrls } from "../../constants/urls";
import FacebookIcon from "@mui/icons-material/Facebook";

const SocialAccountBar = ({ text, onIconClick, onTextClick, isMobile }) => {
  return (
    <Stack
      direction={isMobile ? "column" : "row"}
      spacing={2}
      sx={{ mt: isMobile ? 1 : 8, alignItems: "center" }}
    >
      {/* Icons on the left */}
      <Stack
        direction="row"
        pt={isMobile ? 5 : 0}
        order={isMobile ? 1 : 0}
        spacing={1.5}
      >
        <IconButton
          size="small"
          sx={{ color: darkColors.socialIconsGray }}
          onClick={() => onIconClick(socialRedirectUrls.discord)}
        >
          <img src={assetIcons.discord} alt="discord" />
        </IconButton>
        <IconButton
          size="small"
          sx={{ color: darkColors.socialIconsGray }}
          onClick={() => window.open(socialRedirectUrls.facebook, "_blank")}
        >
          <FacebookIcon />
        </IconButton>
        <IconButton
          size="small"
          sx={{ color: darkColors.socialIconsGray }}
          onClick={() => onIconClick(socialRedirectUrls.twitter)}
        >
          <XIcon />
        </IconButton>
        <IconButton
          size="small"
          sx={{ color: darkColors.socialIconsGray }}
          onClick={() => onIconClick(socialRedirectUrls.tiktok)}
        >
          <img src={assetIcons.tiktok} width={30} height={30} alt="tiktok" />
        </IconButton>
      </Stack>

      {/* Spacer to push the text to the right */}
      <Box sx={{ flex: 1 }} />

      {/* Account text on the right */}
      <Typography
        fontSize="clamp(13px, 1vw, 16px)" // Responsive font size starting at 14px
        fontWeight={600}
        color={darkColors.buttonTop}
        sx={{
          // background: "linear-gradient(to bottom, #FD8804, #8E5009)", // Gradient from top to bottom
          // WebkitBackgroundClip: "text",
          // WebkitTextFillColor: "transparent",
          cursor: "pointer",
          // mt: 0,
        }}
        textAlign={"left"}
        onClick={onTextClick}
      >
        {text}
      </Typography>
    </Stack>
  );
};

export default SocialAccountBar;
